/**
 * Action creator for setting the entire list of coins in the Redux state.
 * @param {Array} coins - The array of coins to be set in the state.
 * @returns {Object} An action object with the type "SET_COINS" and a payload containing the coins data.
 */
const setCoins = (coins) => {
  return {
    type: "SET_COINS",
    payload: coins,
  };
};

/**
 * Action creator for marking a specific coin as starred in the Redux state.
 * @param {string} id - The unique identifier of the coin to be marked as starred.
 * @returns {Object} An action object with the type "SETSTARRED_COIN" and a payload containing the ID of the starred coin.
 */
const setStarredCoin = (id) => {
  return {
    type: "SETSTARRED_COIN",
    payload: id,
  };
};

/**
 * Action creator for unsetting the starred status of a specific coin in the Redux state.
 * @param {string} id - The unique identifier of the coin to be unmarked as starred.
 * @returns {Object} An action object with the type "UNSETSTARRED_COIN" and a payload containing the ID of the unstarred coin.
 */
const unsetStarredCoin = (id) => {
  return {
    type: "UNSETSTARRED_COIN",
    payload: id,
  };
};

export { setCoins, setStarredCoin, unsetStarredCoin };
